export function getVideoDimension(
  videoFile: File,
): Promise<{ width: number; height: number; duration: number }> {
  return new Promise((resolve, reject) => {
    const videoElement = document.createElement('video')
    const url = URL.createObjectURL(videoFile)
    videoElement.setAttribute('src', url)
    videoElement.load()

    videoElement.onloadeddata = () => {
      URL.revokeObjectURL(url)

      resolve({
        duration: videoElement.duration,
        width: videoElement.videoWidth,
        height: videoElement.videoHeight,
      })
    }
    videoElement.onerror = e => {
      reject(e)
    }
  })
}
